import "./listing.scss";

document.addEventListener("DOMContentLoaded", () => {
  const clearAllButton = document.querySelector(".filter-clear");
  const caseListing = document.querySelector(".listing");
  if (!caseListing) {
    return;
  }
  const [...allTags] = document.querySelectorAll(".listing button");
  if (!allTags) {
    return;
  }
  selected.split(",").forEach((category) => {
    const tags = allTags.filter((button) => button.dataset.name == category);
    tags.forEach((tag) => {
      tag.addEventListener("click", () => {
        tag.classList.toggle("active");
        let url = new URL(window.location.href);
        if (tag.classList.contains("active")) {
          if (!clearAllButton.classList.contains("visible")) {
            clearAllButton.classList.add("visible");
          }
          if (tag.dataset.slug === "all") {
            const filteredTags = tags.filter(
              (button) =>
                !button.classList.contains("active") &&
                button.dataset.slug != "all"
            );
            filteredTags.forEach((button) => {
              url = addFilter(url, button);
            });
            window.history.pushState(window.location.href, "", url.href);
            window.location.reload();
          } else {
            url = addFilter(url, tag);
            window.history.pushState(window.location.href, "", url.href);
            window.location.reload();
          }
        } else {
          if (tag.dataset.slug === "all") {
            tags.forEach((button) => {
              url = removeFilter(url, button);
            });
          }
          url = removeFilter(url, tag);
          if (url.href.indexOf("?") == -1) {
            clearAllButton.classList.remove("visible");
          }
          window.history.pushState(window.location.href, "", url.href);
          window.location.reload();
        }
      });
    });
  });

  const addFilter = (url, tag) => {
    let parameter = url.searchParams.get(tag.dataset.name);
    if (parameter) {
      url.searchParams.set(
        tag.dataset.name,
        parameter + "," + tag.dataset.slug
      );
    } else {
      url.searchParams.append(tag.dataset.name, tag.dataset.slug);
    }
    return url;
  };
  const removeFilter = (url, tag) => {
    let parameter = url.searchParams.get(tag.dataset.name);
    if (parameter) {
      if (parameter.includes(",") && parameter.includes(tag.dataset.slug)) {
        url.searchParams.set(
          tag.dataset.name,
          parameter
            .replace(tag.dataset.slug, "")
            .split(",")
            .filter((el) => el != "")
        );
      } else {
        url.searchParams.delete(tag.dataset.name);
      }
    }
    return url;
  };

  const settingsParameters = Object.keys(lazySettings)
    .reduce(function (params, key) {
      params.set("settings[" + key + "]", lazySettings[key]);
      return params;
    }, new URLSearchParams())
    .toString();
  //variables

  //html elements
  const archivePreloader = caseListing.querySelector(".js-listing-preloader");
  let lazyOffset = 1;
  let currentRequest = null;
  let notAllDisplayed = true;

  if (!remainingFirstLoad) {
    archivePreloader.classList.remove("active");
  } else {
    archivePreloader.classList.add("active");
  }

  window.addEventListener("scroll", (e) => {
    if (
      window.innerHeight + window.scrollY >
      document.body.offsetHeight - 300
    ) {
      if (
        currentRequest == null &&
        notAllDisplayed === true &&
        archivePreloader.classList.contains("active")
      ) {
        archivePreloader.classList.add("listing__preloader--visible");
        currentRequest = new XMLHttpRequest();
        currentRequest.open(
          "GET",
          elementApiUrl +
            "?offset=" +
            lazyOffset +
            "&ids=" +
            targetIds +
            "&source-id=" +
            sourceId +
            "&shift=" +
            shift +
            "&" +
            settingsParameters,
          true
        );
        currentRequest.onload = function () {
          archivePreloader.classList.remove("listing__preloader--visible");
          currentRequest = null;
          if (this.status >= 200 && this.status < 400) {
            //Success
            lazyOffset++;
            let html = "";
            const resJson = JSON.parse(this.response);
            resJson.data.forEach((article) => {
              html += article.html;
            });
            archivePreloader.insertAdjacentHTML("beforebegin", html);
            if (
              resJson.data.length === 0 ||
              resJson.meta.pagination.current_page ==
                resJson.meta.pagination.total_pages
            ) {
              notAllDisplayed = false;
              document
                .querySelector(".js-listing-preloader")
                .classList.remove("active");
            }
          }
        };
        currentRequest.send();
      }
    }
  });
});
